import React from 'react';
import {useHistory} from "react-router";
import {useLoading} from "../../../../util/LoadingProvider";
import {makeStyles, Tab, Tabs, Typography} from "@material-ui/core";
import * as yup from "yup";
import Box from "@material-ui/core/Box";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import apiHelper from "../../../../util/ApiHelper";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {ToggleButton, ToggleButtonGroup} from "@material-ui/lab";
import {KeyboardDatePicker, KeyboardTimePicker} from "@material-ui/pickers";
import dayjs from "dayjs";
import {toast} from "react-toastify";

const useStyles = makeStyles((theme) => ({
  tabpanel: {
    background: "#FFFFFF",
  },
  textInput: {
    backgroundColor: "white",
    width: "100%",
    marginBottom: "12px",

    "& input": {
      fontSize: "14px",
    },
  },
  content: {
    "& .ck-editor__editable_inline": {
      minHeight: "200px",
    },
  },
  buttonGroup: {
    marginTop: "20px",
    textAlign: "right",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  box: {
    padding: 0,
  },
  innerBox: {
    background: "#ffffff",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  imageGallery: {
    border: "1px solid #CCCCCC",
    minHeight: "160px",
    borderRadius: "3px",
    position: "relative",
  },
  imageGalleryControl: {
    position: "relative",
    width: "100%",
    display: "flex",
    height: "40px",
    bottom: "0",
    borderTop: "1px solid #CCCCCC",
    padding: "5px",
  },
  imageGalleryBlk: {
    minHeight: "120px",
    padding: "5px",
  },
  imgPreview: {
    maxWidth: "200px",
    margin: "10px",
    display: "inline-flex",
    position: "relative",
    verticalAlign: "top",
    "& img": {
      width: "100%",
      height: "auto",
    },
    "& button": {
      position: "absolute",
      top: "-10px",
      right: "-10px",
      zIndex: "10",
      display: "block",
      color: "rgba(48, 111, 157, 0.8)",
      background: "white",
      padding: 0,
      transition: "200ms all ease-out",
      "&:hover": {
        color: "rgba(48, 111, 157, 1)",
        background: "white",
      },
    },
  },
  permalink: {
    paddingLeft: "5px",
    fontSize: "13px",
    display: "flex",
    alignItems: "center",
    "& .permalink": {
      fontWeight: 700,
    },
  },
  input: {
    width: "100%",
    marginTop: "20px",
    marginLeft: "10px",
    "& button": {
      fontSize: "13px",
      lineHeight: "15px",
      width: "25%",
    },
  },
}));

const defaultFormValues = {
  displayType: "",
  displayDatetime: "",
  seq: 0,
  status: true,
  localizations: {
    en: {
      name: "",
      description: "",
      address: "",
      speaker: "",
      filmDirector: "",
      executiveDirector: "",
      moderator: "",
      title: "",
      seminarName: "",
      dateName: "",
      timeName: "",
    },
    tc: {
      name: "",
      description: "",
      address: "",
      speaker: "",
      filmDirector: "",
      executiveDirector: "",
      moderator: "",
      title: "",
      seminarName: "",
      dateName: "",
      timeName: "",
    },
  },
};

const schema = yup.object().shape({
  localizations: yup.object().shape({
    en: yup.object().shape({
      name: yup.string().required("Name is required."),
    }),
    tc: yup.object().shape({
      name: yup.string().required("Name is required."),
    }),
  }),
});

function TabPanel(props) {
  const classes = useStyles();
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      <Box p={3} className={classes.box}>
        {children}
      </Box>
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

export const EventCategoryDetailPage = ({match, disabled}) => {
  const {id} = match.params;
  const {setLoading} = useLoading();
  const history = useHistory();
  const classes = useStyles();
  const [activeTab, setActiveTab] = React.useState(0);
  const [defaultValues, setDefaultValues] = React.useState(defaultFormValues);
  const [displayDate, setDisplayDate] = React.useState(null);
  const [displayTime, setDisplayTime] = React.useState(null);
  const [dateEn, setDateEn] = React.useState(null);
  const [timeEn, setTimeEn] = React.useState(null);
  const [dateTc, setDateTc] = React.useState(null);
  const [timeTc, setTimeTc] = React.useState(null);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const {
    control,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
    resolver: yupResolver(schema),
  });

  const getEventCategoryById = React.useCallback(async () => {
    try {
      setLoading(true);
      const res = await apiHelper.hkiff.getEventCategoryById(id);
      setDefaultValues(res.data);
      setDisplayDate(dayjs(res.data.displayDateTime).format("YYYY-MM-DD"));
      setDisplayTime(dayjs(res.data.displayDateTime).format("YYYY-MM-DDTHH:mm"));
      if (res.data.localizations.en.timeName) {
        setTimeEn(dayjs(`1999-12-31T${res.data.localizations.en.timeName}`).format("YYYY-MM-DDTHH:mm"));
      }
      if (res.data.localizations.tc.timeName) {
        setTimeTc(dayjs(`1999-12-31T${res.data.localizations.tc.timeName}`).format("YYYY-MM-DDTHH:mm"));
      }
      if (res.data.localizations.en.dateName) {
        setDateEn(dayjs(res.data.localizations.en.dateName).format("YYYY-MM-DD"));
      }
      if (res.data.localizations.tc.dateName) {
        setDateTc(dayjs(res.data.localizations.tc.dateName).format("YYYY-MM-DD"));
      }
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false);
    }
  }, [id])

  const onSubmit = React.useCallback(async (data) => {
    const displayDateTime = displayDate && displayTime ? `${displayDate}T${dayjs(displayTime).format('HH:mm')}:00` : null
    const timeNameEn = timeEn ? `${dayjs(timeEn).format('HH:mm')}:00` : null
    const timeNameTc = timeTc ? `${dayjs(timeTc).format('HH:mm')}:00` : null
    const req = {
      ...data,
      displayDateTime,
      localizations: {
        en: {
          ...data.localizations.en,
          dateName: dateEn,
          timeName: timeNameEn,
        },
        tc: {
          ...data.localizations.tc,
          dateName: dateTc,
          timeName: timeNameTc,
        }
      }
    }
    if (id !== 'new') {
      try {
        setLoading(true)
        await apiHelper.hkiff.updateEventCategoryById(id, req);
        await getEventCategoryById()
        toast.success("Event category updated successfully.");
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    } else {
      try {
        setLoading(true)
        const res = await apiHelper.hkiff.createEventCategory(req);
        toast.success("Event category created successfully.");
        history.push(`/hkiff/event/category/${res.data.id}`)
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    }
  }, [displayDate, displayTime, dateEn, timeEn, dateTc, timeTc])

  React.useEffect(() => {
    async function init() {
      if (id && id !== 'new') {
        await getEventCategoryById()
      }
    }

    init()
  }, [id])

  React.useEffect(() => {
    reset(defaultValues)
  }, [reset, defaultValues])

  return (
    <div className={classes.content}>
      <Typography variant="h4" gutterBottom>
        Event > {id === 'new' ? 'Add Category' : 'Edit Category'}
      </Typography>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="nav tabs example"
        TabIndicatorProps={{style: {top: "0", background: "#306F9D"}}}
      >
        <Tab
          label="English"
          {...a11yProps(0)}
        />
        <Tab
          label="繁體中文"
          {...a11yProps(1)}
        />
      </Tabs>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <TabPanel value={activeTab} index={0}>
            <Box className={classes.innerBox} style={{paddingTop: 32, marginBottom: 0}}>
              <Grid container direction="vertical" spacing={3}>
                <Grid item xs={12}>
                  <Controller
                    name={`localizations.en.name`}
                    control={control}
                    render={({field, fieldState: {error}}) => (
                      <TextField
                        label="Name"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Box fontWeight={900} fontSize={13} mt={2} ml={2} width="100%">
                    <Typography variant="p">
                      Display Template
                    </Typography>
                  </Box>
                  <Controller
                    control={control}
                    name="displayType"
                    render={({
                               field: {value, onChange, ...rest},
                               fieldState: {error},
                             }) => (
                      <ToggleButtonGroup
                        {...rest}
                        value={value}
                        onChange={(event, newFormats) => {
                          if (newFormats !== null) {
                            onChange(newFormats);
                          }
                        }}
                        exclusive
                        aria-label="Display Type"
                        className={classes.input}
                      >
                        <ToggleButton
                          value={'image'}
                          aria-label="Image"
                          style={{width: "50%"}}
                        >
                          Image
                        </ToggleButton>
                        <ToggleButton
                          value={'image&text'}
                          aria-label="Image & Text"
                          style={{width: "50%"}}
                        >
                          Image & Text
                        </ToggleButton>
                      </ToggleButtonGroup>
                    )}
                  />
                </Grid>
                <Grid item xs={12} style={{marginLeft: 6}}>
                  <Grid container item xs={6} spacing={3}>
                    <Grid item xs={6}>
                      <Box fontWeight={900} fontSize={13} mt={2} ml={1} width="100%">
                        <Typography variant="p">
                          Display Date
                        </Typography>
                      </Box>
                      <KeyboardDatePicker
                        id={`date-picker`}
                        fullWidth
                        disabled={disabled}
                        margin="dense"
                        variant="inline"
                        label="Date"
                        value={displayDate}
                        onChange={(date, value) => {
                          setDisplayDate(dayjs(date).format('YYYY-MM-DD'))
                        }}
                        onError={console.log}
                        format="dd/MM/yyyy"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={6}
                    >
                      <Box fontWeight={900} fontSize={13} mt={2} ml={1} width="100%">
                        <Typography variant="p">
                          Display Time
                        </Typography>
                      </Box>
                      <KeyboardTimePicker
                        id={`time-picker`}
                        fullWidth
                        minutesStep={5}
                        disabled={disabled}
                        margin="dense"
                        variant="inline"
                        ampm={false}
                        label="Time"
                        value={displayTime}
                        onChange={(time, value) => {
                          setDisplayTime(dayjs(time).format('YYYY-MM-DDTHH:mm'))
                        }}
                        onError={console.log}
                        format="HH:mm"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Box fontWeight={900} fontSize={13} mt={4} ml={2} mb={2} width="100%">
                    <Typography variant="p">
                      Category Details
                    </Typography>
                  </Box>
                  <Controller
                    name={`localizations.en.address`}
                    control={control}
                    render={({field, fieldState: {error}}) => (
                      <TextField
                        label="Address"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      name={`localizations.en.speaker`}
                      control={control}
                      render={({field, fieldState: {error}}) => (
                        <TextField
                          label="Speaker"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name={`localizations.en.filmDirector`}
                      control={control}
                      render={({field, fieldState: {error}}) => (
                        <TextField
                          label="Film Director"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      name={`localizations.en.executiveDirector`}
                      control={control}
                      render={({field, fieldState: {error}}) => (
                        <TextField
                          label="Executive Director"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name={`localizations.en.moderator`}
                      control={control}
                      render={({field, fieldState: {error}}) => (
                        <TextField
                          label="Moderator"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      name={`localizations.en.title`}
                      control={control}
                      render={({field, fieldState: {error}}) => (
                        <TextField
                          label="Title"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name={`localizations.en.seminarName`}
                      control={control}
                      render={({field, fieldState: {error}}) => (
                        <TextField
                          label="Seminar Name"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} style={{marginLeft: 6}}>
                  <Grid container item xs={6} spacing={3}>
                    <Grid item xs={6}>
                      <Box fontWeight={900} fontSize={13} mt={2} ml={1} width="100%">
                        <Typography variant="p">
                          Date
                        </Typography>
                      </Box>
                      <KeyboardDatePicker
                        id={`date-picker`}
                        fullWidth
                        disabled={disabled}
                        margin="dense"
                        variant="inline"
                        label="Date"
                        value={dateEn}
                        onChange={(date, value) => {
                          setDateEn(dayjs(date).format('YYYY-MM-DD'))
                        }}
                        onError={console.log}
                        format="dd/MM/yyyy"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={6}
                    >
                      <Box fontWeight={900} fontSize={13} mt={2} ml={1} width="100%">
                        <Typography variant="p">
                          Time
                        </Typography>
                      </Box>
                      <KeyboardTimePicker
                        id={`time-picker`}
                        fullWidth
                        minutesStep={5}
                        disabled={disabled}
                        margin="dense"
                        variant="inline"
                        ampm={false}
                        label="Time"
                        value={timeEn}
                        onChange={(time, value) => {
                          setTimeEn(dayjs(time).format('YYYY-MM-DDTHH:mm'))
                        }}
                        onError={console.log}
                        format="HH:mm"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Controller
                    control={control}
                    name="localizations.en.description"
                    render={({field, fieldState: {error}}) => (
                      <TextField
                        multiline
                        rows={5}
                        variant="outlined"
                        margin="dense"
                        label="Description"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} container direction="vertical" spacing={3}>
                  <Grid item xs={4}>
                    <Controller
                      control={control}
                      name="status"
                      render={({
                                 field: {value, onChange, ...rest},
                                 fieldState: {error},
                               }) => (
                        <ToggleButtonGroup
                          {...rest}
                          value={value}
                          onChange={(event, newFormats) => {
                            if (newFormats !== null) {
                              onChange(newFormats);
                            }
                          }}
                          exclusive
                          aria-label="Status"
                          className={classes.input}
                        >
                          <ToggleButton
                            value={true}
                            aria-label="Active"
                            style={{width: "50%"}}
                          >
                            Active
                          </ToggleButton>
                          <ToggleButton
                            value={false}
                            aria-label="Inactive"
                            style={{width: "50%"}}
                          >
                            Inactive
                          </ToggleButton>
                        </ToggleButtonGroup>
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
          <TabPanel value={activeTab} index={1}>
            <Box className={classes.innerBox} style={{paddingTop: 32, marginBottom: 0}}>
              <Grid container direction="vertical" spacing={3}>
                <Grid item xs={12}>
                  <Controller
                    name={`localizations.tc.name`}
                    control={control}
                    render={({field, fieldState: {error}}) => (
                      <TextField
                        label="Name"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Box fontWeight={900} fontSize={13} mt={2} ml={2} width="100%">
                    <Typography variant="p">
                      Display Template
                    </Typography>
                  </Box>
                  <Controller
                    control={control}
                    name="displayType"
                    render={({
                               field: {value, onChange, ...rest},
                               fieldState: {error},
                             }) => (
                      <ToggleButtonGroup
                        {...rest}
                        value={value}
                        onChange={(event, newFormats) => {
                          if (newFormats !== null) {
                            onChange(newFormats);
                          }
                        }}
                        exclusive
                        aria-label="Display Type"
                        className={classes.input}
                      >
                        <ToggleButton
                          value={'image'}
                          aria-label="Image"
                          style={{width: "50%"}}
                        >
                          Image
                        </ToggleButton>
                        <ToggleButton
                          value={'image&text'}
                          aria-label="Image & Text"
                          style={{width: "50%"}}
                        >
                          Image & Text
                        </ToggleButton>
                      </ToggleButtonGroup>
                    )}
                  />
                </Grid>
                <Grid item xs={12} style={{marginLeft: 6}}>
                  <Grid container item xs={6} spacing={3}>
                    <Grid item xs={6}>
                      <Box fontWeight={900} fontSize={13} mt={2} ml={1} width="100%">
                        <Typography variant="p">
                          Display Date
                        </Typography>
                      </Box>
                      <KeyboardDatePicker
                        id={`date-picker`}
                        fullWidth
                        disabled={disabled}
                        margin="dense"
                        variant="inline"
                        label="Date"
                        value={displayDate}
                        onChange={(date, value) => {
                          setDisplayDate(dayjs(date).format('YYYY-MM-DD'))
                        }}
                        onError={console.log}
                        disablePast
                        format="dd/MM/yyyy"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={6}
                    >
                      <Box fontWeight={900} fontSize={13} mt={2} ml={1} width="100%">
                        <Typography variant="p">
                          Display Time
                        </Typography>
                      </Box>
                      <KeyboardTimePicker
                        id={`time-picker`}
                        fullWidth
                        minutesStep={5}
                        disabled={disabled}
                        margin="dense"
                        variant="inline"
                        ampm={false}
                        label="Time"
                        value={displayTime}
                        onChange={(time, value) => {
                          setDisplayTime(dayjs(time).format('YYYY-MM-DDTHH:mm'))
                        }}
                        onError={console.log}
                        disablePast
                        format="HH:mm"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Box fontWeight={900} fontSize={13} mt={4} ml={2} mb={2} width="100%">
                    <Typography variant="p">
                      Category Details
                    </Typography>
                  </Box>
                  <Controller
                    name={`localizations.tc.address`}
                    control={control}
                    render={({field, fieldState: {error}}) => (
                      <TextField
                        label="Address"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      name={`localizations.tc.speaker`}
                      control={control}
                      render={({field, fieldState: {error}}) => (
                        <TextField
                          label="Speaker"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name={`localizations.tc.filmDirector`}
                      control={control}
                      render={({field, fieldState: {error}}) => (
                        <TextField
                          label="Film Director"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      name={`localizations.tc.executiveDirector`}
                      control={control}
                      render={({field, fieldState: {error}}) => (
                        <TextField
                          label="Executive Director"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name={`localizations.tc.moderator`}
                      control={control}
                      render={({field, fieldState: {error}}) => (
                        <TextField
                          label="Moderator"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      name={`localizations.tc.title`}
                      control={control}
                      render={({field, fieldState: {error}}) => (
                        <TextField
                          label="Title"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name={`localizations.tc.seminarName`}
                      control={control}
                      render={({field, fieldState: {error}}) => (
                        <TextField
                          label="Seminar Name"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} style={{marginLeft: 6}}>
                  <Grid container item xs={6} spacing={3}>
                    <Grid item xs={6}>
                      <Box fontWeight={900} fontSize={13} mt={2} ml={1} width="100%">
                        <Typography variant="p">
                          Date
                        </Typography>
                      </Box>
                      <KeyboardDatePicker
                        id={`date-picker`}
                        fullWidth
                        disabled={disabled}
                        margin="dense"
                        variant="inline"
                        label="Date"
                        value={dateTc}
                        onChange={(date, value) => {
                          setDateTc(dayjs(date).format('YYYY-MM-DD'))
                        }}
                        onError={console.log}
                        format="dd/MM/yyyy"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={6}
                    >
                      <Box fontWeight={900} fontSize={13} mt={2} ml={1} width="100%">
                        <Typography variant="p">
                          Time
                        </Typography>
                      </Box>
                      <KeyboardTimePicker
                        id={`time-picker`}
                        fullWidth
                        minutesStep={5}
                        disabled={disabled}
                        margin="dense"
                        variant="inline"
                        ampm={false}
                        label="Time"
                        value={timeTc}
                        onChange={(time, value) => {
                          setTimeTc(dayjs(time).format('YYYY-MM-DDTHH:mm'))
                        }}
                        onError={console.log}
                        format="HH:mm"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Controller
                    control={control}
                    name="localizations.tc.description"
                    render={({field, fieldState: {error}}) => (
                      <TextField
                        multiline
                        rows={5}
                        variant="outlined"
                        margin="dense"
                        label="Description"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} container direction="vertical" spacing={3}>
                  <Grid item xs={4}>
                    <Controller
                      control={control}
                      name="status"
                      render={({
                                 field: {value, onChange, ...rest},
                                 fieldState: {error},
                               }) => (
                        <ToggleButtonGroup
                          {...rest}
                          value={value}
                          onChange={(event, newFormats) => {
                            if (newFormats !== null) {
                              onChange(newFormats);
                            }
                          }}
                          exclusive
                          aria-label="Status"
                          className={classes.input}
                        >
                          <ToggleButton
                            value={true}
                            aria-label="Active"
                            style={{width: "50%"}}
                          >
                            Active
                          </ToggleButton>
                          <ToggleButton
                            value={false}
                            aria-label="Inactive"
                            style={{width: "50%"}}
                          >
                            Inactive
                          </ToggleButton>
                        </ToggleButtonGroup>
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
          {disabled || (
            <div className={classes.buttonGroup}>
              <Button
                type="submit"
                variant="contained"
                disableElevation
                style={{
                  color: "white",
                  background: "#306F9D",
                  marginRight: "5px",
                  padding: "9px 16px",
                }}
              >
                {id === 'new' ? 'Create' : 'Save Changes'}
              </Button>
            </div>
          )}
        </fieldset>
      </form>
    </div>
  );
}